// Desregistro del service worker viejo de crm.wiservet.com (build de mayo en
// /opt/wiservet-crm). La plataforma nueva NO usa service worker: cualquier
// registro en este origen es del CRM viejo y su caché serviría HTML y chunks
// muertos. Complementa al "kill switch" de public/sw.js.

export interface SwCleanupResult {
  unregistered: number;
  cachesDeleted: number;
  /** true si la página seguía controlada por el SW viejo (conviene recargar). */
  wasControlled: boolean;
}

type SwContainer = Pick<ServiceWorkerContainer, 'getRegistrations'> & {
  controller?: ServiceWorker | null;
};
type CacheApi = Pick<CacheStorage, 'keys' | 'delete'>;

export async function unregisterLegacyServiceWorkers(
  sw: SwContainer | undefined = typeof navigator !== 'undefined' ? navigator.serviceWorker : undefined,
  cacheApi: CacheApi | undefined = typeof caches !== 'undefined' ? caches : undefined,
): Promise<SwCleanupResult> {
  const result: SwCleanupResult = { unregistered: 0, cachesDeleted: 0, wasControlled: false };
  if (sw?.getRegistrations) {
    result.wasControlled = !!sw.controller;
    const regs = await sw.getRegistrations();
    for (const reg of regs) {
      if (await reg.unregister()) result.unregistered += 1;
    }
  }
  if (cacheApi) {
    for (const key of await cacheApi.keys()) {
      if (await cacheApi.delete(key)) result.cachesDeleted += 1;
    }
  }
  return result;
}

const RELOAD_GUARD_KEY = 'wiservet-pn:sw-cleanup-reloaded';

/**
 * Limpia y, si la página venía servida por el SW viejo, recarga UNA vez por
 * sesión de pestaña para traer el index.html nuevo desde la red.
 */
export async function cleanupLegacyServiceWorkerAndReload(): Promise<void> {
  try {
    const r = await unregisterLegacyServiceWorkers();
    if (r.wasControlled && !sessionStorage.getItem(RELOAD_GUARD_KEY)) {
      sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
      window.location.reload();
    }
  } catch {
    // Navegador sin soporte o modo privado: nada que limpiar.
  }
}
